import {Inject, Injectable, Optional, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import { HttpErrorResponse, HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize, tap} from "rxjs/operators";
import {environment} from "../../../environments/environment";
import {RESPONSE} from '../providers/http-context-providers';
import type {Response} from 'express';

@Injectable()
export class ResponseHttpInterceptor implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: object,
    @Optional() @Inject(RESPONSE) private readonly response: Response | null,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!isPlatformBrowser(this.platformId) && this.response) {
      const started = performance.now();
      let status = 0;
      return next.handle(req).pipe(
        tap({
          next: event => { if (event instanceof HttpResponse) status = event.status; },
          error: (error: HttpErrorResponse) => { status = error.status || 0; },
        }),
        finalize(() => {
          const requests = this.response.locals['wtgSsrRequests'] ||= [];
          requests.push({
            method: req.method,
            path: new URL(req.url, environment.appUrl).pathname,
            status,
            durationMs: Math.round(performance.now() - started),
          });
        }),
      );
    }

    if (environment.production === false) {
      const started = Date.now();
      let ok: string;
      // extend server response observable with logging
      return next.handle(req)
          .pipe(
              tap(
                  event => ok = event instanceof HttpResponse ? 'succeeded' : '',
                  error => {
                    ok = 'failed';
                  }
              ),
              // Log when response observable either completes or errors
              finalize(() => {
                const elapsed = Date.now() - started;
                const msg = `${req.method} "${req.urlWithParams}" ${ok} in ${elapsed} ms.`;
              })
          );
    }

    return next.handle(req).pipe(tap(() => {
    }, () => {
    }));
  }
}
